module.exports = __webpack_public_path__ + "static/media/img_background_basketball.4e7f4ee4.jpg";